import React, { useState } from 'react'
import { GButton, TextArea } from 'tennders-common/form/components'
import useSession from 'tennders-auth/hooks/useSession'
import useTranslation from 'next-translate/useTranslation'

export const CommentBox = ({ params, postComment, isBothVisible }) => {
  const { t } = useTranslation('transaction')
  const { isShipperUser, isCarrierUser } = useSession()
  const [body, setbody] = useState('')
  const [submitting, setsubmitting] = useState(false)

  const submit = async (e) => {
    if (e) {
      e.preventDefault()
    }
    setsubmitting(true)
    await postComment({ ...params, body })
    setbody('')
    setsubmitting(false)
  }

  return (
    <div className={isBothVisible ? 'w-50' : 'w-100'}>
      <div className="pr-10">
        <TextArea
          value={body}
          onSet={setbody}
          className="form-textarea"
          row={5}
          placeHolder={t((isShipperUser ? 'comment_to_carrier' : isCarrierUser ? 'comment_to_shipper' : ''), { fallback: '' })}
        />
        <GButton
          disabled={body.length < 2}
          submitting={submitting}
          onClick={submit}
          className="btn-border standard-btn cursor-pointer medium"
          labelKey="transaction:send"
        />
      </div>
    </div>
  )
}
